import InteractionEvent, {
  type InteractionTargetType
} from './InteractionEvent';

export const ALL_SIZES = 'ALL_SIZES';

// Where the size grid was. Absent is the PDP's where-to-buy grid; notification_modal is the
// alert modal's grid, kept apart so a size asked to be alerted on is not read as a size shopped.
export type SizePlacement = 'notification_modal';

export type SizeTargetProperties = {
  placement?: SizePlacement;
  product_id: string;
  selected_size: string;
};

type EventData = {
  gesture?: string;
  guestId?: string;
  isBot: boolean;
  placement?: SizePlacement;
  productId: string;
  selectedSize?: string;
};

class SizeInteractionEvent extends InteractionEvent<
  EventData,
  SizeTargetProperties
> {
  protected get targetType(): InteractionTargetType {
    return 'size';
  }

  protected getTargetProperties(): SizeTargetProperties {
    return {
      placement: this.data.placement,
      product_id: this.data.productId,
      selected_size: this.data.selectedSize || ALL_SIZES
    };
  }
}

export default SizeInteractionEvent;
